import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext } from '../context';
import { Icon } from '../icon';
import { FolderLockIcon } from 'icons';

export const SoundBoarIconButton = (props) => (
  <Icon Type={FolderLockIcon} tw='flex-shrink-0' {...props} />
);

export const SoundBoardMobileButton = () => {
  const { windowSize, setSoundBoardActive } = useContext(AppContext);

  return (
    <>
      {!['DESKTOP'].includes(windowSize.adBreakPoint) && (
        <SoundBoarIconButton onClick={() => setSoundBoardActive(true)} />
      )}
    </>
  );
};
